import React, { useEffect, useState } from "react";
import { getAuth, signOut } from "firebase/auth";
import { getFirestore, collection, query, where, getDocs, onSnapshot } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import app, { programHeadAuth } from "../../firebase";

const auth = programHeadAuth;

export default function StudentCourseLineup() {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [phDepartment, setPhDepartment] = useState("");
  const [phName, setPhName] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const profilePicUrl = "https://ui-avatars.com/api/?name=" + (phName || "Program Head");

  // Auth state listener - maintain session and redirect if not authenticated
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        navigate("/academics");
      }
    });
    return unsubscribe;
  }, [navigate]);

  useEffect(() => {
    const fetchProgramHeadDepartment = async () => {
      const user = auth.currentUser;
      if (!user) {
        setPhDepartment("");
        setPhName("");
        setLoading(false);
        return;
      }
      const db = getFirestore(app);
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("email", "==", user.email));
      const snap = await getDocs(q);
      if (!snap.empty) {
        const data = snap.docs[0].data();
        setPhDepartment(data.department || "");
        setPhName(data.name || "");
      }
    };
    fetchProgramHeadDepartment();
  }, []);

  useEffect(() => {
    if (!phDepartment) {
      setStudents([]);
      return;
    }
    
    setLoading(true);
    const db = getFirestore(app);
    const studentsRef = collection(db, "students");
    const q = query(
      studentsRef,
      where("preRegistrationStatus", "==", "submitted"),
      where("program", "==", phDepartment)
    );
    
    const unsubscribe = onSnapshot(q, (snap) => {
      setStudents(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      setLoading(false);
    }, (err) => {
      console.error("Error fetching students:", err);
      setStudents([]);
      setLoading(false);
    });
    
    return unsubscribe;
  }, [phDepartment]);

  // Logout handler
  const handleLogout = async () => {
    await signOut(auth);
    navigate("/academics");
  };

  // Modal state for viewing student details
  const [selectedStudent, setSelectedStudent] = useState(null);
  const handleView = (student) => {
    setSelectedStudent(student);
  };
  const handleCloseModal = () => setSelectedStudent(null);

  const handleAddCourseLineup = (student) => {
    navigate(`/program-head/student-schedule/${student.id}`);
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f5f5f5", display: "flex", flexDirection: "row" }}>
      {/* Sidebar */}
      <div style={{ width: 220, background: "#155c2b", color: "#fff", display: "flex", flexDirection: "column", alignItems: "stretch", padding: "32px 0", minHeight: "100vh", boxShadow: "2px 0 8px #eee" }}>
        <div style={{ fontWeight: 700, fontSize: 22, textAlign: "center", marginBottom: 40, letterSpacing: 2 }}>ENROLLEASE</div>
        
        <button onClick={() => navigate("/program-head")} style={{ background: "transparent", color: "#fff", border: "none", borderRadius: 6, padding: "14px 0", fontWeight: 600, fontSize: 17, cursor: "pointer", textAlign: "left", paddingLeft: 32, marginBottom: 8, marginRight: 12, transition: "background 0.2s" }}>Home</button>
        <button onClick={() => navigate("/program-head?page=curriculum-flowchart")} style={{ background: "transparent", color: "#fff", border: "none", borderRadius: 6, padding: "14px 0", fontWeight: 600, fontSize: 17, cursor: "pointer", textAlign: "left", paddingLeft: 32, marginBottom: 8, marginRight: 12, transition: "background 0.2s" }}>Curriculum Flowchart</button>
        <button onClick={() => navigate("/program-head?page=scheduling")} style={{ background: "transparent", color: "#fff", border: "none", borderRadius: 6, padding: "14px 0", fontWeight: 600, fontSize: 17, cursor: "pointer", textAlign: "left", paddingLeft: 32, marginBottom: 8, marginRight: 12, transition: "background 0.2s" }}>Scheduling</button>
        <button onClick={() => navigate("/program-head/student-course-lineup")} style={{ background: "#e67e22", color: "#fff", border: "none", borderRadius: 6, padding: "14px 0", fontWeight: 600, fontSize: 17, cursor: "pointer", textAlign: "left", paddingLeft: 32, marginBottom: 8, marginRight: 12, boxShadow: "0 2px 8px #e67e22aa" }}>Course Line-up</button>
        <div style={{ flex: 1 }} />
      </div>

      {/* Main area */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        {/* Header */}
        <div style={{ height: 80, background: "#fff", display: "flex", alignItems: "center", boxShadow: "0 2px 8px rgba(0,0,0,0.04)", padding: "0 40px", position: "relative", zIndex: 10, justifyContent: "space-between" }}>
          <h1 style={{ margin: "0", fontSize: 24, color: "#155c2b", fontWeight: 600 }}>Course Line-up</h1>
          
          <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
            <span style={{ marginRight: 16, fontWeight: 600, fontSize: 18, color: "#155c2b" }}>{phName || "Program Head"}</span>
            <button onClick={() => setDropdownOpen(!dropdownOpen)} style={{ background: "none", border: "none", cursor: "pointer", padding: 0, display: "flex", alignItems: "center" }}>
              <img src={profilePicUrl} alt="Profile" style={{ width: 44, height: 44, borderRadius: "50%", objectFit: "cover", border: "2px solid #e67e22" }} />
            </button>
            
            {dropdownOpen && (
              <div style={{ position: "absolute", top: "100%", right: 0, marginTop: 8, background: "#fff", border: "1px solid #e0e0e0", borderRadius: 8, boxShadow: "0 4px 16px rgba(0,0,0,0.1)", zIndex: 20, minWidth: 200, overflow: "hidden" }}>
                <div style={{ padding: "12px 16px", fontWeight: 600, color: "#155c2b", borderBottom: "1px solid #f0f0f0" }}>{phName || "Program Head"}</div>
                <button onClick={() => { setDropdownOpen(false); handleLogout(); }} style={{ width: "100%", padding: "12px 16px", background: "transparent", border: "none", color: "#e67e22", fontSize: 14, fontWeight: 600, cursor: "pointer", textAlign: "left", transition: "background 0.2s" }} onMouseEnter={e => e.target.style.background = "#fef5f0"} onMouseLeave={e => e.target.style.background = "transparent"}>Log out</button>
              </div>
            )}
          </div>
        </div>

        {/* Content Area */}
        <div style={{ flex: 1, padding: 40, overflowY: "auto" }}>
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <div style={{ marginTop: 24 }}>
        {loading ? (
          <div style={{ color: "#888" }}>Loading students...</div>
        ) : students.length === 0 ? (
          <div style={{ color: "#888" }}>No students found who have completed Pre-Registration for your department.</div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 16, background: "#fff" }}>
            <thead>
              <tr style={{ background: "#f9f9f9" }}>
                <th style={{ border: "1px solid #ccc", padding: 8 }}>ID Number</th>
                <th style={{ border: "1px solid #ccc", padding: 8 }}>Name</th>
                <th style={{ border: "1px solid #ccc", padding: 8 }}>Program</th>
                <th style={{ border: "1px solid #ccc", padding: 8 }}>Entry Level</th>
                <th style={{ border: "1px solid #ccc", padding: 8 }}>Semester</th>
                <th style={{ border: "1px solid #ccc", padding: 8 }}>Date Submitted</th>
                <th style={{ border: "1px solid #ccc", padding: 8 }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {students.map(student => (
                <tr key={student.id}>
                  <td style={{ border: "1px solid #ccc", padding: 8 }}>{student.idNumber}</td>
                  <td style={{ border: "1px solid #ccc", padding: 8 }}>{student.firstName} {student.lastName}</td>
                  <td style={{ border: "1px solid #ccc", padding: 8 }}>{student.program}</td>
                  <td style={{ border: "1px solid #ccc", padding: 8 }}>{student.preRegistration?.entryLevel || '-'}</td>
                  <td style={{ border: "1px solid #ccc", padding: 8 }}>{student.preRegistration?.semester || '-'}</td>
                  <td style={{ border: "1px solid #ccc", padding: 8 }}>{student.preRegistrationSubmittedAt ? new Date(student.preRegistrationSubmittedAt).toLocaleString() : '-'}</td>
                  <td style={{ border: "1px solid #ccc", padding: 8 }}>
                    <button onClick={() => handleView(student)} style={{ background: '#18803b', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 18px', fontWeight: 600, fontSize: 15, cursor: 'pointer' }}>View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
            </div>
          </div>
        </div>
      </div>

      {/* Student Details Modal */}
      {selectedStudent && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.18)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 12, minWidth: 900, maxWidth: 1000, maxHeight: '90vh', padding: 40, boxShadow: '0 4px 24px rgba(0,0,0,0.12)', position: 'relative', fontSize: 15, overflowY: 'auto' }}>
            <button onClick={handleCloseModal} style={{ position: 'absolute', top: 18, right: 18, background: '#e67e22', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 18px', fontWeight: 600, fontSize: 15, cursor: 'pointer' }}>Close</button>
            {/* Header Info */}
            <div style={{ display: 'flex', gap: 40, marginBottom: 18 }}>
              <div><b>Department:</b><br /><div style={{ background: '#eee', padding: '6px 24px', borderRadius: 6, minWidth: 180 }}>{selectedStudent.program}</div></div>
              <div><b>Entry Level:</b><br /><div style={{ background: '#eee', padding: '6px 24px', borderRadius: 6, minWidth: 180 }}>{selectedStudent.preRegistration?.entryLevel || '-'}</div></div>
              <div><b>Semester:</b><br /><div style={{ background: '#eee', padding: '6px 24px', borderRadius: 6, minWidth: 180 }}>{selectedStudent.preRegistration?.semester || '-'}</div></div>
            </div>
            <hr style={{ margin: '18px 0 24px 0', border: 'none', borderTop: '2px solid #e5e7eb' }} />
            {/* Basic Information */}
            <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 12 }}>Basic Information</div>
            <div style={{ display: 'flex', gap: 40, marginBottom: 18 }}>
              <div>
                <div><b>Last Name:</b> <span style={{ background: '#ffffffff', padding: '4px 18px', borderRadius: 6 }}>{selectedStudent.lastName}</span></div>
                <div><b>First Name:</b> <span style={{ background: '#ffffffff', padding: '4px 18px', borderRadius: 6 }}>{selectedStudent.firstName}</span></div>
                <div><b>Middle Name:</b> <span style={{ background: '#ffffffff', padding: '4px 18px', borderRadius: 6 }}>{selectedStudent.middleName || 'N/A'}</span></div>
                <div><b>Birth Date:</b> <span style={{ background: '#ffffffff', padding: '4px 18px', borderRadius: 6 }}>{selectedStudent.dob || '-'}</span></div>
                <div><b>Gender:</b> <span style={{ background: '#ffffffff', padding: '4px 18px', borderRadius: 6 }}>{selectedStudent.gender || '-'}</span></div>
              </div>
              <div>
                <div><b>Nationality:</b> <span style={{ background: '#ffffffff', padding: '4px 18px', borderRadius: 6 }}>{selectedStudent.preRegistration?.nationality || '-'}</span></div>
                <div><b>Religion:</b> <span style={{ background: '#ffffffff', padding: '4px 18px', borderRadius: 6 }}>{selectedStudent.preRegistration?.religion || '-'}</span></div>
                <div><b>Civil Status:</b> <span style={{ background: '#ffffffff', padding: '4px 18px', borderRadius: 6 }}>{selectedStudent.preRegistration?.civilStatus || '-'}</span></div>
                <div><b>Mobile No:</b> <span style={{ background: '#ffffffff', padding: '4px 18px', borderRadius: 6 }}>{selectedStudent.mobile || '-'}</span></div>
                <div><b>Email Address:</b> <span style={{ background: '#ffffffff', padding: '4px 18px', borderRadius: 6 }}>{selectedStudent.email || '-'}</span></div>
              </div>
            </div>
            {/* Requirements Table */}
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 32, marginTop: 18 }}>
              <thead>
                <tr style={{ background: '#f9f9f9' }}>
                  <th style={{ border: '1px solid #ccc', padding: 8 }}>Requirements</th>
                  <th style={{ border: '1px solid #ccc', padding: 8 }}>Copy</th>
                  <th style={{ border: '1px solid #ccc', padding: 8 }}>File</th>
                </tr>
              </thead>
              <tbody>
                {/* Show submitted images for each requirement */}
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>2x2 Picture</td>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>E-copy</td>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>
                    {selectedStudent.picture ? (
                      <a href={selectedStudent.picture} target="_blank" rel="noopener noreferrer">
                        <button style={{ background: '#18803b', color: '#fff', border: 'none', borderRadius: 6, padding: '4px 14px', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}>View</button>
                      </a>
                    ) : (
                      <span style={{ color: '#888' }}>No image</span>
                    )}
                  </td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>PSA</td>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>E-copy</td>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>
                    {selectedStudent.birthCert ? (
                      <a href={selectedStudent.birthCert} target="_blank" rel="noopener noreferrer">
                        <button style={{ background: '#18803b', color: '#fff', border: 'none', borderRadius: 6, padding: '4px 14px', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}>View</button>
                      </a>
                    ) : (
                      <span style={{ color: '#888' }}>No image</span>
                    )}
                  </td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>Copy of Grades</td>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>E-copy</td>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>
                    {selectedStudent.grades ? (
                      <a href={selectedStudent.grades} target="_blank" rel="noopener noreferrer">
                        <button style={{ background: '#18803b', color: '#fff', border: 'none', borderRadius: 6, padding: '4px 14px', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}>View</button>
                      </a>
                    ) : (
                      <span style={{ color: '#888' }}>No image</span>
                    )}
                  </td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>Latest School ID / Gov ID</td>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>E-copy</td>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>
                    {selectedStudent.schoolId ? (
                      <a href={selectedStudent.schoolId} target="_blank" rel="noopener noreferrer">
                        <button style={{ background: '#18803b', color: '#fff', border: 'none', borderRadius: 6, padding: '4px 14px', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}>View</button>
                      </a>
                    ) : (
                      <span style={{ color: '#888' }}>No image</span>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
            {/* Education Section */}
            <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 12 }}>Education</div>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 32 }}>
              <thead>
                <tr style={{ background: '#f9f9f9' }}>
                  <th style={{ border: '1px solid #ccc', padding: 8 }}>Elementary</th>
                  <th style={{ border: '1px solid #ccc', padding: 8 }}>Junior High School</th>
                  <th style={{ border: '1px solid #ccc', padding: 8 }}>Senior High School</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>
                    <div style={{ fontWeight: 700 }}>{selectedStudent.preRegistration?.elementary?.school || '-'}</div>
                    <div style={{ color: '#888' }}>Address: {selectedStudent.preRegistration?.elementary?.address || '-'}</div>
                    <div style={{ color: '#888' }}>{selectedStudent.preRegistration?.elementary?.year ? `${selectedStudent.preRegistration?.elementary?.year}` : '-'}</div>
                  </td>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>
                    <div style={{ fontWeight: 700 }}>{selectedStudent.preRegistration?.junior?.school || '-'}</div>
                    <div style={{ color: '#888' }}>Address: {selectedStudent.preRegistration?.junior?.address || '-'}</div>
                    <div style={{ color: '#888' }}>{selectedStudent.preRegistration?.junior?.year ? `${selectedStudent.preRegistration?.junior?.year}` : '-'}</div>
                  </td>
                  <td style={{ border: '1px solid #ccc', padding: 8 }}>
                    <div style={{ fontWeight: 700 }}>{selectedStudent.preRegistration?.senior?.school || '-'}</div>
                    <div style={{ color: '#888' }}>Address: {selectedStudent.preRegistration?.senior?.address || '-'}</div>
                    <div style={{ color: '#888' }}>{selectedStudent.preRegistration?.senior?.year ? `${selectedStudent.preRegistration?.senior?.year}` : '-'}</div>
                    <div style={{ color: '#888' }}>Track Strand: {selectedStudent.preRegistration?.senior?.strand || '-'}</div>
                  </td>
                </tr>
              </tbody>
            </table>
            {/* Family Section */}
            <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 12 }}>Family</div>
            <div style={{ background: '#f8fafb', borderRadius: 8, padding: 18, border: '1px solid #e5e7eb', marginBottom: 18 }}>
              <div style={{ fontWeight: 700, fontSize: 17 }}>{selectedStudent.preRegistration?.parentName?.toUpperCase() || '-'}</div>
              <div>Relationship: {selectedStudent.preRegistration?.relationship || '-'}</div>
              <div>Occupation: {selectedStudent.preRegistration?.occupation || '-'}</div>
              <div>Address: {selectedStudent.preRegistration?.familyAddress || '-'}</div>
              <div>Mobile No: {selectedStudent.preRegistration?.familyMobile || '-'}</div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 32 }}>
              <button onClick={() => handleAddCourseLineup(selectedStudent)} style={{ background: '#18803b', color: '#fff', border: 'none', borderRadius: 6, padding: '12px 32px', fontWeight: 700, fontSize: 16, cursor: 'pointer' }}>ADD COURSE LINE-UP</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
